export default __webpack_public_path__ + "static/media/holycow.e46511bc.png";